module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-a7ba1b0107ed2a9d5c527a70683e1133.png";